import React from 'react';
import PropTypes from 'prop-types';
import TabsNavigation from '../TabsNavigation';
import Tab from '../Tab';
import Divider from '../Divider/Divider';

const LanguageTabs = ({
  languages,
  activeTabIndex,
  setActiveTabIndex,
  showDivider = true,
  testIdPrefix = 'language-tab',
  dividerClassName = '-mt-[1px] border-0 border-b',
  fullLanguages = []
}) => {
  return (
    <>
      <TabsNavigation
        handleSetActiveTab={setActiveTabIndex}
        activeTabIndex={activeTabIndex}>
        {languages.map((lang, index) => {
          const key =
            typeof lang === 'string' ? lang : lang.code || lang.id || index;
          let label = '';

          if (typeof lang === 'string') {
            const found = fullLanguages.find((l) => (l.code || l.id) === lang);
            label = found?.title || found?.name || lang.toUpperCase();
          } else {
            label = lang.title || lang.name || key.toString().toUpperCase();
          }

          return (
            <Tab
              key={key}
              label={label}
              data-testid={`${testIdPrefix}-${key}`}
            />
          );
        })}
      </TabsNavigation>
      {showDivider && <Divider className={dividerClassName} />}
    </>
  );
};

LanguageTabs.propTypes = {
  languages: PropTypes.array.isRequired,
  activeTabIndex: PropTypes.number.isRequired,
  setActiveTabIndex: PropTypes.func.isRequired,
  showDivider: PropTypes.bool,
  testIdPrefix: PropTypes.string,
  dividerClassName: PropTypes.string
};

export default React.memo(LanguageTabs);
